export default {
	activeViewKey: '5f02bf8f-e034-45f8-81b0-5266fd54af8a',
	interferometry: {
		fidColumnName: 'id_global',
		mapSetKey: 'interferometry',
		mapKey: 'interferometry',
		smallMapKey: 'interferometry-small',
		selectionKey: 'interferometry',
		layerKeys: {
			points: 'interferometryPoints',
			pointsSmall: 'interferometryPointsSmall',
			zones: 'interferometryZones',
			zonesSmall: 'interferometryZonesSmall',
			zonesCoastal: 'interferometryZonesCoastal',
			zonesCoastalSmall: 'interferometryZonesCoastalSmall',
			zonesRiparian: 'interferometryZonesRiparian',
			zonesRiparianSmall: 'interferometryZonesRiparianSmall',
		},
		layersOrder: [],
		idMasks: {
			los: '####_##_####_11_######',
			dts: '####_##_####_13_######',
			vertg: '####_##_####_12_######',
			vertggps: '####_##_####_14_######',
		},
	},
	zones: {
		fidColumnName: 'zone_id',
		mapSetKey: 'zones',
		mapKey: 'zones',
		smallMapKey: 'zones-small',
		selectionKey: 'zones',
		layerKeys: {
			zones: 'zones',
			zonesSmall: 'zonesSmall',
			zonesCoastal: 'zonesCoastal',
			zonesCoastalSmall: 'zonesCoastalSmall',
			zonesRiparian: 'zonesRiparian',
			zonesRiparianSmall: 'zonesRiparianSmall',
		},
		attributeSets: [
			'land_urban_blocks',
			'zonal_statistics',
			'zonal_frequency_reliability',
			'zonal_frequency_hazard',
		],
	},
	layerOrder: {
		interferometry: [
			'interferometryZones',
			'interferometryZonesCoastal',
			'interferometryZonesRiparian',
			'interferometryPoints',
		],
		'interferometry-small': [
			'interferometryZonesSmall',
			'interferometryZonesCoastalSmall',
			'interferometryZonesRiparian',
			'interferometryPointsSmall',
		],
		zones: ['zones', 'zonesCoastal', 'zonesRiparian'],
		'zones-small': ['zonesSmall', 'zonesCoastalSmall', 'zonesRiparian'],
	},
	layerStyles: {
		zones: {
			active: 'zonesExposure',
			available: ['zonesBase', 'zonesExposure', 'zonesTypology'],
		},
		zonesCoastal: {
			active: null,
			available: ['zonesCoastal'],
		},
		zonesRiparian: {
			active: null,
			available: ['zonesRiparian'],
		},
		interferometryZones: {
			active: 'zonesBase',
			available: ['zonesBase', 'zonesExposure', 'zonesTypology'],
		},
		interferometryZonesCoastal: {
			active: null,
			available: ['zonesCoastal'],
		},
		interferometryZonesRiparian: {
			active: null,
			available: ['zonesRiparian'],
		},
	},
	bigSmallMapPairs: {
		maps: {
			interferometry: 'interferometry-small',
			zones: 'zones-small',
		},
		layers: {
			interferometryZones: 'interferometryZonesSmall',
			interferometryZonesCoastal: 'interferometryZonesCoastalSmall',
			interferometryZonesRiparian: 'interferometryZonesRiparianSmall',
			interferometryPoints: 'interferometryPointsSmall',
			zones: 'zonesSmall',
			zonesCoastal: 'zonesCoastalSmall',
			zonesRiparian: 'zonesRiparianSmall',
		},
		styles: {
			zonesExposure: 'zonesExposureSmall',
			zonesTypology: 'zonesTypologySmall',
			zonesBase: 'zonesBase',
			zonesCoastal: 'zonesCoastalSmall',
			zonesRiparian: 'zonesRiparianSmall',
		},
	},
	wmsLayersGroups: [
		{
			name: 'Elevation',
			description:
				'© DLR e.V. 2010-2014 and © Airbus Defence and Space GmbH 2014-2018 provided under COPERNICUS by the European Union and ESA; all rights reserved.',
			layers: ['elevation', 'height', 'slope'],
		},
		{
			name: 'Reference point, permanent stations & dam site',
			layers: ['refPoints', 'damSite'],
		},
	],
};
